import type { RJSFSchema } from "@rjsf/utils";
import { InfoIcon } from "../../components/skills/icons";

export function explainedOptions(schema: RJSFSchema) {
  return (schema.oneOf ?? []).filter(
    (option): option is { title: string; description: string } =>
      typeof option === "object" && typeof option.title === "string" && typeof option.description === "string");
}

/** The field's explanation and its options', behind an info glyph beside the label. */
export function FieldInfo({ about, schema }: { about?: string; schema: RJSFSchema }) {
  const explained = explainedOptions(schema);
  if (!about && !explained.length) return null;
  const text = [about, ...explained.map(option => `${option.title}：${option.description}`)].filter(Boolean).join("\n");
  return <span className="info-tip work-settings-option-info" tabIndex={0} role="note" aria-label={text}>
    <InfoIcon size={14} />
    <span className="info-tip-bubble" role="tooltip">
      {about && <span className="work-settings-info-about">{about}</span>}
      {explained.map(option => <span key={option.title}><strong>{option.title}</strong>{option.description}</span>)}
    </span>
  </span>;
}
